import { round } from 'lodash';

const convertToMegabytes = (numInBytes: number): string =>
  `${round(numInBytes / 1000 / 1000, 2)}   MB`;

export default convertToMegabytes;
